export default __webpack_public_path__ + "static/media/eye-off.5024cf84.svg";